<div
    [ngClass]="{
        'cards-wrapper--no-margin-top': isBenefitsMainLandingPage,
        'cards-wrapper--compact': !isFilterable && !isDisplayCount && !hasNavControls,
        'list-is-active': cardLayout === 'list',
        'grid-is-active': cardLayout !== 'list',
    }"
    class="cards-wrapper cards-wrapper--{{ getCardsType() }}">
    @if (showPreText()) {
        @if (block.data.heading && getCardsType() === 'articles') {
            <h1 [innerText]="block.data.heading" class="post-h1"></h1>
        }
        @if (block.data.heading && getCardsType() !== 'articles') {
            <h2 [innerText]="block.data.heading" class="cards-wrapper__heading"></h2>
        }
        @if (block.data.text) {
            <div [innerHtml]="block.data.text" class="lead"></div>
        }
    }
    @if (isFilterable || isDisplayCount || hasNavControls) {
        <div class="cards-wrapper__filters">
            @if (isFilterable && (pillars$ | async); as pillars) {
                <ul class="nav nav-pills nav-benefits">
                    @for (pillar of pillars; track pillar.id ?? pillar.name) {
                        <li class="nav-item">
                            <a
                                (click)="filterPillar(pillar)"
                                [innerText]="pillar.name | translate"
                                [ngClass]="{
                                    active: pillar.id === filteredBy || (!filteredBy && pillar.name === 'All'),
                                }"
                                aria-current="page"
                                class="nav-link"
                                href="javascript:void(0)"></a>
                        </li>
                    }
                </ul>
                <div class="dropdown dropdown-benefits" dropdown>
                    <button
                        aria-controls="dropdown-pillars"
                        aria-expanded="false"
                        class="btn btn-secondary dropdown-toggle"
                        dropdownToggle
                        type="button">
                        <span [class]="'pillar-icon pillar-icon--' + selectedValue | lowercase"></span>
                        {{ selectedValue }}
                        <svg fill="none" height="6" viewBox="0 0 10 6" width="10" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 0.943359L5 5.94336L5.96244e-08 0.943359L0.8875 0.0558591L5 4.16836L9.1125 0.0558592L10 0.943359Z"
                                fill="#1C1B1F" />
                        </svg>
                    </button>
                    <ul *bsDropdownMenu aria-labelledby="benefits-dropdown" class="dropdown-menu" role="menu">
                        @for (pillar of pillars; track pillar.id ?? pillar.name) {
                            <li>
                                <a
                                    (click)="filterPillar(pillar); changeDropdownName(pillar.name)"
                                    [ngClass]="{
                                        active: pillar.id === filteredBy || (!filteredBy && pillar.name === 'All'),
                                    }"
                                    aria-current="page"
                                    class="dropdown-item"
                                    href="javascript:void(0)">
                                    <span [innerText]="pillar.name"></span
                                ></a>
                            </li>
                        }
                    </ul>
                </div>
            }
            <div class="cards-wrapper__pills-sub">
                <div class="d-flex align-items-center ms-auto">
                    @if (!isLoading && isDisplayCount) {
                        <span>
                            <span [innerText]="'Displaying' | translate"></span>&nbsp;<strong
                                [innerText]="getDisplayCount()"></strong
                            >&nbsp;<span [innerText]="'of' | translate"></span>&nbsp;<strong
                                [innerText]="total"></strong
                            >&nbsp;<span [innerText]="getArticleType()"></span>
                        </span>
                    }
                    @if (hasNavControls) {
                        <div class="nav-controls float-end">
                            <button (click)="changeLayout('grid')" class="nav-controls__grid">
                                <svg height="19" viewBox="0 0 18 19" width="18" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16.3125 0.25C16.7695 0.25 17.1562 0.425781 17.5078 0.742188C17.8242 1.09375 18 1.48047 18 1.9375V13.1875C18 13.6797 17.8242 14.0664 17.5078 14.3828C17.1562 14.7344 16.7695 14.875 16.3125 14.875H14.625V16.5625C14.625 17.0547 14.4492 17.4414 14.1328 17.7578C13.7812 18.1094 13.3945 18.25 12.9375 18.25H1.6875C1.19531 18.25 0.808594 18.1094 0.492188 17.7578C0.140625 17.4414 0 17.0547 0 16.5625V5.3125C0 4.85547 0.140625 4.46875 0.492188 4.11719C0.808594 3.80078 1.19531 3.625 1.6875 3.625H3.375V1.9375C3.375 1.48047 3.51562 1.09375 3.86719 0.742188C4.18359 0.425781 4.57031 0.25 5.0625 0.25H16.3125ZM12.7266 16.5625C12.7617 16.5625 12.7969 16.5625 12.8672 16.4922C12.9023 16.457 12.9375 16.4219 12.9375 16.3516V14.875H5.0625C4.57031 14.875 4.18359 14.7344 3.86719 14.3828C3.51562 14.0664 3.375 13.6797 3.375 13.1875V5.3125H1.89844C1.82812 5.3125 1.79297 5.34766 1.75781 5.38281C1.6875 5.45312 1.6875 5.48828 1.6875 5.52344V16.3516C1.6875 16.4219 1.6875 16.457 1.75781 16.4922C1.79297 16.5625 1.82812 16.5625 1.89844 16.5625H12.7266ZM16.1016 13.1875C16.1367 13.1875 16.1719 13.1875 16.2422 13.1172C16.2773 13.082 16.3125 13.0469 16.3125 12.9766V2.14844C16.3125 2.11328 16.2773 2.07812 16.2422 2.00781C16.1719 1.97266 16.1367 1.9375 16.1016 1.9375H5.27344C5.20312 1.9375 5.16797 1.97266 5.13281 2.00781C5.0625 2.07812 5.0625 2.11328 5.0625 2.14844V12.9766C5.0625 13.0469 5.0625 13.082 5.13281 13.1172C5.16797 13.1875 5.20312 13.1875 5.27344 13.1875H16.1016Z" />
                                </svg>
                            </button>
                            <button (click)="changeLayout('list')" class="nav-controls__list">
                                <svg height="15" viewBox="0 0 18 15" width="18" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M17.5781 2.60938C17.6836 2.60938 17.7891 2.57422 17.8594 2.50391C17.9297 2.43359 18 2.32812 18 2.1875V1.0625C18 0.957031 17.9297 0.851562 17.8594 0.78125C17.7891 0.710938 17.6836 0.640625 17.5781 0.640625H4.92188C4.78125 0.640625 4.67578 0.710938 4.60547 0.78125C4.53516 0.851562 4.5 0.957031 4.5 1.0625V2.1875C4.5 2.32812 4.53516 2.43359 4.60547 2.50391C4.67578 2.57422 4.78125 2.60938 4.92188 2.60938H17.5781ZM18 7.8125C18 7.95312 17.9297 8.05859 17.8594 8.12891C17.7891 8.19922 17.6836 8.23438 17.5781 8.23438H4.92188C4.78125 8.23438 4.67578 8.19922 4.60547 8.12891C4.53516 8.05859 4.5 7.95312 4.5 7.8125V6.6875C4.5 6.58203 4.53516 6.47656 4.60547 6.40625C4.67578 6.33594 4.78125 6.26562 4.92188 6.26562H17.5781C17.6836 6.26562 17.7891 6.33594 17.8594 6.40625C17.9297 6.47656 18 6.58203 18 6.6875V7.8125ZM18 13.4375C18 13.5781 17.9297 13.6836 17.8594 13.7539C17.7891 13.8242 17.6836 13.8594 17.5781 13.8594H4.92188C4.78125 13.8594 4.67578 13.8242 4.60547 13.7539C4.53516 13.6836 4.5 13.5781 4.5 13.4375V12.3125C4.5 12.207 4.53516 12.1016 4.60547 12.0312C4.67578 11.9609 4.78125 11.8906 4.92188 11.8906H17.5781C17.6836 11.8906 17.7891 11.9609 17.8594 12.0312C17.9297 12.1016 18 12.207 18 12.3125V13.4375ZM3.23438 2.75C3.23438 2.89062 3.16406 2.99609 3.09375 3.06641C3.02344 3.13672 2.91797 3.17188 2.8125 3.17188H0.5625C0.421875 3.17188 0.316406 3.13672 0.246094 3.06641C0.175781 2.99609 0.140625 2.89062 0.140625 2.75V0.5C0.140625 0.394531 0.175781 0.289062 0.246094 0.21875C0.316406 0.148438 0.421875 0.078125 0.5625 0.078125H2.8125C2.91797 0.078125 3.02344 0.148438 3.09375 0.21875C3.16406 0.289062 3.23438 0.394531 3.23438 0.5V2.75ZM3.23438 8.375C3.23438 8.51562 3.16406 8.62109 3.09375 8.69141C3.02344 8.76172 2.91797 8.79688 2.8125 8.79688H0.5625C0.421875 8.79688 0.316406 8.76172 0.246094 8.69141C0.175781 8.62109 0.140625 8.51562 0.140625 8.375V6.125C0.140625 6.01953 0.175781 5.91406 0.246094 5.84375C0.316406 5.77344 0.421875 5.70312 0.5625 5.70312H2.8125C2.91797 5.70312 3.02344 5.77344 3.09375 5.84375C3.16406 5.91406 3.23438 6.01953 3.23438 6.125V8.375ZM3.23438 14C3.23438 14.1406 3.16406 14.2461 3.09375 14.3164C3.02344 14.3867 2.91797 14.4219 2.8125 14.4219H0.5625C0.421875 14.4219 0.316406 14.3867 0.246094 14.3164C0.175781 14.2461 0.140625 14.1406 0.140625 14V11.75C0.140625 11.6445 0.175781 11.5391 0.246094 11.4688C0.316406 11.3984 0.421875 11.3281 0.5625 11.3281H2.8125C2.91797 11.3281 3.02344 11.3984 3.09375 11.4688C3.16406 11.5391 3.23438 11.6445 3.23438 11.75V14Z" />
                                </svg>
                            </button>
                        </div>
                    }
                </div>
            </div>
        </div>
    }

    <div
        (scrolled)="onScroll()"
        [infiniteScrollDistance]="distance"
        [infiniteScrollThrottle]="throttle"
        [ngClass]="[getCardColumnsClasses(), getTypeClass(block.data.type)]"
        class="g-4 cards-wrapper__inner"
        infinite-scroll>
        @if (!isCarousel && isBrowser) {
            @for (
                card of cards.slice(0, hardLimit ?? cards.length) | orderBy: getOrderString();
                track card.id ?? card
            ) {
                <div class="col">
                    <core-client-block-card
                        [cardType]="card.type ?? block.data.type"
                        [card]="card"
                        [cardLinkText]="block.data.linkText"
                        [includeCtaIcon]="
                            block.data.includeCtaIcon === 1 ||
                            block.data.includeCtaIcon === true ||
                            block.data.includeCtaIcon === '1'
                        "
                        [buttonIcon]="block.data.buttonIcon"
                        [cardLinkColor]="
                            block.data.changeLinkColour === 1 ||
                            block.data.changeLinkColour === true ||
                            block.data.changeLinkColour === '1'
                                ? block.data.linkColour
                                : undefined
                        "
                        [imageType]="block.data.imageType"
                        [imageAlign]="block.data.imageAlign"
                        [imageSize]="block.data.imageSize ?? 'medium'"
                        [showBorder]="block.data.showBorder ?? false"
                        [showBoxShadow]="block.data.showBoxShadow ?? false"
                        [cardBoxShadowColor]="
                            block.data.useCustomBoxShadowColor === 1 ||
                            block.data.useCustomBoxShadowColor === true ||
                            block.data.useCustomBoxShadowColor === '1'
                                ? block.data.boxShadowColor
                                : undefined
                        "
                        [displayImages]="isDisplayImages ?? true"
                        [displayTags]="isDisplayTags"
                        [showDateModified]="isShowDateModified"
                        [showTitleArrow]="
                            block.data.showTitleArrow === 1 ||
                            block.data.showTitleArrow === true ||
                            block.data.showTitleArrow === '1'
                        "
                        [cardPrimaryHeader]="
                            block.data.cardPrimaryHeader === 1 ||
                            block.data.cardPrimaryHeader === true ||
                            block.data.cardPrimaryHeader === '1'
                        "
                        [cardTitleColor]="
                            block.data.useCustomCardTitleStyles === 1 ||
                            block.data.useCustomCardTitleStyles === true ||
                            block.data.useCustomCardTitleStyles === '1'
                                ? block.data.cardTitleColor
                                : undefined
                        "
                        [cardTitleFontSize]="
                            block.data.useCustomCardTitleStyles === 1 ||
                            block.data.useCustomCardTitleStyles === true ||
                            block.data.useCustomCardTitleStyles === '1'
                                ? block.data.cardTitleFontSize
                                : undefined
                        "
                        [cardTitleFontWeight]="
                            block.data.useCustomCardTitleStyles === 1 ||
                            block.data.useCustomCardTitleStyles === true ||
                            block.data.useCustomCardTitleStyles === '1'
                                ? block.data.cardTitleFontWeight
                                : undefined
                        "
                        [cardBackgroundColor]="block.data.cardBackgroundColor"></core-client-block-card>
                </div>
            }

            @if (isLoading) {
                @for (shimmer of getShimmerCards(); track shimmer) {
                    <div class="col">
                        <core-block-card-shimmer></core-block-card-shimmer>
                    </div>
                }
            }
        }
    </div>

    @if (isCarousel) {
        <core-block-cards-carousel
            [blockIndex]="block.id"
            [cardTypeClass]="getTypeClass(block.data.type)"
            [cardType]="block.data.type"
            [cards]="cards"
            [displayImages]="isDisplayImages"
            [displayTags]="isDisplayTags"
            [grouping]="limit"
            [hasTopNav]="block.data.topNav ?? false"
            [imageType]="block.data.imageType"
            [imageAlign]="block.data.imageAlign"></core-block-cards-carousel>
        @if (isLoading) {
            <div [ngClass]="[getCardColumnsClasses(), getTypeClass(block.data.type)]" class="g-4 cards-wrapper__inner">
                @for (shimmer of getShimmerCards(); track shimmer) {
                    <div class="col">
                        <core-block-card-shimmer></core-block-card-shimmer>
                    </div>
                }
            </div>
        }
    }

    @if (
        !isCarousel &&
        isLandingLink &&
        total > 0 &&
        getExploreLink() &&
        getExploreLink().getUrl() &&
        getExploreLink().getLabel()
    ) {
        <div class="d-flex justify-content-center mt-5 mb-3">
            <a
                [innerText]="getExploreLink().getLabel() | translate"
                [routerLink]="getExploreLink().getUrl()"
                class="btn btn-primary mb-0"></a>
        </div>
    }

    @if (isPaginated && getPageLinks().length > 1 && (!isLazy || cards.length < total)) {
        <nav aria-label="Card pagination" class="mt-5">
            <ul class="pagination justify-content-center flex-wrap">
                <li class="page-item">
                    @if (offset > 0) {
                        <a (click)="previousPage()" aria-label="Previous" class="page-link" href="javascript:void(0)">
                            <span aria-hidden="true">&laquo;</span>
                            <span [innerText]="'Previous' | translate" class="sr-only"></span>
                        </a>
                    }
                </li>
                @for (link of getPageLinks(); track link.offset; let index = $index) {
                    <li [ngClass]="{ active: link.active }" class="page-item">
                        <a (click)="navigateOffset(link.offset)" class="page-link" href="javascript:void(0)">{{
                            index + 1
                        }}</a>
                    </li>
                }
                <li class="page-item">
                    @if (total > limit + offset) {
                        <a (click)="nextPage()" aria-label="Next" class="page-link" href="javascript:void(0)">
                            <span aria-hidden="true">&raquo;</span>
                            <span [innerText]="'Next' | translate" class="sr-only"></span>
                        </a>
                    }
                </li>
            </ul>
        </nav>
    }

    @if (block.data.includeCTA) {
        <a
            class="btn btn-primary cards-wrapper__cta"
            [class]="
                'cards-wrapper__cta--' + block.data.ctaVariant + ' ' + 'cards-wrapper__cta--' + block.data.ctaTheme
            "
            [href]="block.data.ctaLink"
            [target]="block.data.externalLink ? '_target' : '_self'"
            [innerText]="block.data.ctaText | translate"></a>
    }
</div>
